// Current date AND time in Zurich as "YYYY-MM-DD HH:mm:ss".
// Use it to only query entries that are already published.

// NOV-7726: SBS likes to hide future entries in Newshub and Teaser but not the direct link (do not use the dated collection "hide future" filter).
export const useNowInZurich = () =>
  useState('now-in-zurich', () => {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(new Date())
      .reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {})

    // Seconds are always :00 – the CMS stores entry dates with minute precision
    // (time_seconds_enabled: false), and a stable value keeps the GraphQL cache useful.
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:00`
  }).value
